import { Link } from 'preact-router'

export const Footer = () => (
  <footer>
    <div class="container text-muted ">
      <div className="row">
        <div className="col">
          <Link class="text-muted mr-4" href="/terms">
            Terms
          </Link>
          <Link class="text-muted" href="/privacy">
            Privacy
          </Link>
        </div>
        <div className="col text-right">Manter © 2018</div>
      </div>
    </div>
  </footer>
)



// WEBPACK FOOTER //
// ./components/Footer.js